<div class="addCoin animate__animated animate__fadeIn">

  <p *ngIf="successMessage" class="successMessage">
    {{ successMessage }}
  </p>
  <div class="formContent">
    <div class="row">
      <div class="col-lg-4 v-align">
        <h1>
          Drop us a line. 👋
          <span>
            We'd love to hear from you.
          </span>
          <span>
            If you are interested in advertising or have any questions, please send us a message using the contact form. We'll get back to you as soon as possible.
            <br><br>
            You can also contact us via email <a href="mailto:contact@coincatapult.com">contact@coincatapult.com</a> or
            <a href="https://t.me/coincatapult_marketing" target="_blank">Telegram</a>
          </span>
        </h1>
      </div>
      <div class="col-lg-8 v-align">
        <form id="addCoinForm" #form="ngForm" role="form" novalidate autocomplete="off">
          <div class="row">
            <div class="col-lg-12">
              <div class="form-group">
                <label>Name*</label>
                <div class="inputBox">
                  <input maxlength="30" class="form-control" [(ngModel)]="contact.name" #contactName="ngModel" name="contactName" type="text" [ngClass]="{ 'is-invalid': submitted && contactName.errors && contactName.errors.required }" required>
                </div>
                <p *ngIf="contactName.errors && submitted" class="formError animate__animated ">
                  <span *ngIf="contactName.errors.required">
                     {{ 'fieldRequired' | translate }}
                  </span>
                </p>
              </div>

              <div class="form-group">
                <label>Email*</label>
                <div class="inputBox">
                  <input maxlength="50" class="form-control" [(ngModel)]="contact.email" #contactEmail="ngModel" name="contactEmail" type="text" [ngClass]="{ 'is-invalid': submitted && contactEmail.errors && contactEmail.errors.required }" required email>
                </div>
                <p *ngIf="contactName.errors && submitted" class="formError animate__animated ">
                  <span *ngIf="contactName.errors.required">
                     {{ 'fieldRequired' | translate }}
                  </span>
                  <span *ngIf="contactName.errors.email">
                     {{ 'invalidEmail' | translate }}
                  </span>
                </p>
              </div>
              <div class="form-group">
                <label>Subject*</label>
                <div  class="inputBox">
                  <ng-select [items]="subjects"
                             bindLabel="name"
                             bindValue="value"
                             [(ngModel)]="contact.subject"
                             #contactSubject="ngModel" name="contactSubject"
                             placeholder="Select subject"
                             class="custom"
                             [ngClass]="{ 'is-invalid': submitted && contactSubject.errors && contactSubject.errors.required }" required>
                  </ng-select>
                </div>

                <p *ngIf="contactSubject.errors && submitted" class="formError animate__animated ">
                  <span *ngIf="contactSubject.errors.required">
                    {{ 'fieldRequired' | translate }}
                  </span>
                </p>
              </div>
              <div class="form-group">
                <label>Message*</label>
                <div class="inputBox">
                  <textarea maxlength="2000" class="form-control" [(ngModel)]="contact.message" #contactMessage="ngModel" name="contactMessage" type="text" [ngClass]="{ 'is-invalid': submitted && contactMessage.errors && contactMessage.errors.required }" required></textarea>
                </div>
                <p *ngIf="contactMessage.errors && submitted" class="formError animate__animated ">
                  <span *ngIf="contactMessage.errors.required">
                     {{ 'fieldRequired' | translate }}
                  </span>
                </p>
              </div>
            </div>
            <div class="col-lg-12 buttonLoading">
              <button (click)="save(form)" class="btn btn-primary-custom">
                <span *ngIf="!loading">
                  Send
                </span>
                <div *ngIf="loading" class="buttonLoading">
                  <div class="lds-ring page"><div></div><div></div><div></div><div></div></div>
                </div>
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>

</div>
